// ビルドツールで差し込むこと

export {};

if ('window' in self && !('AudioContext' in self)) {
    window.AudioContext = (self as any).webkitAudioContext;
}

if (!Array.prototype.includes) {
    Array.prototype.includes = function <T>(v: T) {
        return this.indexOf(v) >= 0;
    };
}
